// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"03d64822","98":"90253b39","142":"0e2a0e94","255":"8c450b63","328":"20de56b2","387":"ebbe5c34","441":"722efa77","652":"116469f5","671":"cf79d2f5","680":"417dc412","723":"a59e97a9","867":"cde10720","923":"75311cb0"}[chunkId] + ".chunk.js";
};